import { render, staticRenderFns } from "./editPriorityMapping.vue?vue&type=template&id=933d150c"
import script from "./editPriorityMapping.vue?vue&type=script&lang=js"
export * from "./editPriorityMapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports